import { MatDialog } from '@angular/material/dialog';
import { Injectable } from '@angular/core';
import { DialogComponent } from 'src/app/views/share/dialog/dialog.component';

@Injectable({
  providedIn: 'root',
})
export class DialogService {
  constructor(private dialog: MatDialog) {}

  // Open the dialog only if no dialog is already active
  openDialog(config: any, callback: (action: boolean) => void): void {
    // Check if there are any active dialogs
    const activeDialogs = this.dialog.openDialogs;
    if (activeDialogs.length === 0) {
      const dialogRef = this.dialog.open(DialogComponent, {
        width: '400px',
        data: config,
      });

      dialogRef.afterClosed().subscribe((result) => {
        if (result === 'confirm') {
          callback(true);
        } else {
          callback(false);
        }
      });
    } else {
      console.log('Dialog is already open, not opening a new one.');
    }
  }
}
